import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// تأكد من جلب الرابط الأساسي من البيئة
const API_BASE_URL = process.env.REACT_APP_API_PLAN_URL; 

export const fetchTeacherDataByNfc = createAsyncThunk(
  // ✅ تم التعديل هنا: تغيير الاسم الداخلي لمنع التداخل مع دالة GET
  'session/fetchTeacherDataByNfc', 
  async (nfcId, { rejectWithValue }) => {
    try {
      // إرسال طلب POST لجلب بيانات المعلم والخطة باستخدام nfcId
      const response = await axios.post(`${API_BASE_URL}nfc/teacher-data/${nfcId}`);
      
      return response.data; // يُرجع الكائن { status, message, data }
    } catch (error) {
      // إرجاع رسالة الخطأ القادمة من الباك إند تحديداً لعرضها للمستخدم
      return rejectWithValue(
        error.response?.data?.message || "فشل جلب بيانات الخطة من السيرفر. يرجى المحاولة لاحقاً."
      );
    }
  }
);